<template>
  <section class="appointment-booking">
    <Chatbot
      key="chatbot"
      class="chatbot"
      :flow="appointmentBookingFlow"
      @finished="() => null" />

    <Footer />
  </section>
</template>

<script>
import appointmentBookingFlow from "@/chatbot-flows/appointment-booking.flow.js"
import Chatbot from "@/components/chatbot/Chatbot"
import Footer from "@/components/ui/Footer"

export default {
  name: "AppointmentBooking",
  components: {
    Chatbot,
    Footer
  },
  data() {
    return { appointmentBookingFlow }
  },
  mounted() {
    this.$store.commit("appointmentBooking/flow/resetState")
    this.$store.commit("appointmentBooking/flow/setWorkspaceId", this.$route.params.appCode)
  }
}
</script>

<style lang="scss" scoped>
.appointment-booking {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  overflow: hidden;

  .chatbot {
    flex: 1;
  }
}
</style>
